export default "__VITE_ASSET__9VSC3Z2X__"